import { Component, OnInit,ElementRef, ViewChild,AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { DetArchivoService } from 'src/app/service/det-archivo.service';
import { DetParticipanteService } from 'src/app/service/det-participante.service';
import { DetParticipanteE } from 'src/app/model/det-participante-bean';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-dml-firmado',
  templateUrl: './dml-firmado.component.html',
  styleUrls: ['./dml-firmado.component.scss']
})
export class DmlFirmadoComponent implements OnInit {
  constructor(
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
   // public  modalRefFirmaDml: MDBModalRef,
    private utilitarioService:UtilitarioService,
    private detArchivoService:DetArchivoService,
    private detParticipanteService:DetParticipanteService,
  ){}


   tempBlob:Blob;
  //variables enviado desde el padre
  x_titulo:string="FIRMA DIGITAL";
  a_tipo:string;
  x_tipo:string;

  tipo_firma:string;
  ruta_regreso:string;
  c_constancia:String;
  c_participante:String;
  pdfRutaBlob:string;


  urlSafe: SafeResourceUrl;
  ParticipanteE:DetParticipanteE;

  ngOnInit(): void {
    //console.log('ini-pre->'+localStorage.getItem('iterador'));
    //this.pageRefresh();//recuperar parametro
    this.route.params.subscribe((params: Params) => {
      //console.log(params);
        this.tipo_firma = params['tipo'];
        var c_id = params['id'];

        //ruta regreso
        if(this.tipo_firma==='r')
          this.ruta_regreso = 'gestionparticipante';
        else
          this.ruta_regreso = 'gestionparticipantefirma';

        // es resultado firma Unitaria o consulta Firma
        if(this.tipo_firma==='u')
          this.x_titulo = "Resultado de Firma Digital de : ";
        else //consulta firma de Firmante(f) o de Registrador(r)
          this.x_titulo = "";

          this.c_participante = c_id;
          this.cargarDatoInicial();
    });
  }


  cargarDatoInicial(){
    this.utilitarioService.loading = true;
    const cargaDatosFirma  = this.detParticipanteService.get(this.c_participante.toString()).toPromise()
    .then(result => {
      this.ParticipanteE = result[0];
      if(this.ParticipanteE.c_tipo==='19')
      {
        this.a_tipo = 'a';
        this.x_tipo = 'Alumnos';
      }
      else
      {
        this.a_tipo = 'p';
        this.x_tipo = 'Profesores';
      }
      console.log(this.a_tipo);
      this.c_constancia = this.ParticipanteE.c_constancia;
      this.x_titulo += this.ParticipanteE.x_nombres;
    });
    Promise.all([cargaDatosFirma])
    .then(response => {
      console.log(this.ParticipanteE.x_uid_pdf);
      const cargarArchivo = this.detArchivoService.getFile(this.ParticipanteE.x_uid_pdf.toString()).toPromise()
        .then(blobData => {
        this.tempBlob = new Blob([blobData], { type: 'application/pdf' });

        console.log("script");
        this.pdfRutaBlob = window.URL.createObjectURL(this.tempBlob);

        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfRutaBlob);
        console.log(this.pdfRutaBlob);

        this.utilitarioService.loading = false;
      });
    });
  }

  onDescargarArchivo(){
    saveAs(this.tempBlob,"firmado"+this.c_participante+".pdf");
  }
}
